import { Component, Inject, OnInit } from "@angular/core";
import type { HubConnection } from '@microsoft/signalr';
import { LibroFacturasEmitidas, LibroFacturasRecibidas } from "./accounting-import.model";
import { AccountingAccountsService } from "../accounting-accounts/accounting-accounts.service";
import { environment } from "../../../../environments/environment";
import { consts } from "../../../consts";
import * as FileSaver from 'file-saver';
import { ImportSumasSaldosComponent } from "./import-sumas-saldos.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "convfact-accounting-import",
    templateUrl: "./accounting-import.component.html",
    styleUrls: ["./accounting-import.component.scss"],
    standalone: false
})

export class AccountingImportComponent implements OnInit {

  constructor(
    public accountingService: AccountingAccountsService,
    public dialog: MatDialog,
  ) { }

  // El <select> nativo de app-select no tiene placeholder aquí, así que el navegador
  // ya muestra "Facturas Emitidas" seleccionada por ser la primera opción; si el modelo
  // arranca en '' nunca coincide con lo que se ve y el usuario nunca dispara (change).
  selectedOption: string = 'emitidas';

  tipoFacturaOptions = [
    { label: 'Facturas Emitidas', value: 'emitidas' },
    { label: 'Facturas Recibidas', value: 'recibidas' },
  ];

  done = false;
  loading = false;
  importDone = false;
  error = false;
  errorList: string[];
  preview = false;

  formData: FormData;
  fileSelected = false;

  importBookEmitidas: LibroFacturasEmitidas = new LibroFacturasEmitidas();
  importBookRecibidas: LibroFacturasRecibidas = new LibroFacturasRecibidas();

  dataSourceEmitidas: LibroFacturasEmitidas[];
  dataSourceRecibidas: LibroFacturasRecibidas[];

  emitidas = false;
  recibidas = false;

  progress: number = 0;
  hubConnection: HubConnection;

  async ngOnInit(): Promise<void> {
    const signalR = await import('@microsoft/signalr');
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.apiUrl + consts.HUB_PROGRESS)
      .build();

    this.hubConnection.start()
      .then(() => console.log('Conectado a SignalR'))
      .catch(err => console.error('Error al conectar con SignalR', err));

    this.hubConnection.on('ReceiveProgress', (data: number) => {
      console.log('Recibido progreso:', data);
      this.progress = data;
    });
  }

  importSumasSaldos() {
    this.dialog.open(ImportSumasSaldosComponent, {
      //width: '60%',
      //height: '70%',
    });

  }

  downloadExcel() {
    this.accountingService.downloadExcel().then(response => {
      FileSaver.saveAs(response, "Plantilla_saldos.xlsx");
    })
  }

  //Guardamos el fichero a importar
  fileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      this.formData = formData;
      this.fileSelected = true;
    }
  }

  onImportClick(): void {
    this.progress = 0;
    this.preview = true;
    if (this.selectedOption === 'emitidas') {
      this.recibidas = false;
      this.emitidas = true;

      this.accountingService.previewBook(this.formData, true).then(response => {
        if (response.error) {
          this.error = true;
          this.preview = false;
          if (Array.isArray(response.data)) {
            this.errorList = response.data.map(item => item.toString());
          }
        }

        this.dataSourceEmitidas = response.data as LibroFacturasEmitidas[];
        this.preview = false;
      })
      this.done = true;
    } else if (this.selectedOption === 'recibidas') {
      this.emitidas = false;
      this.recibidas = true;

      this.accountingService.previewBook(this.formData, false).then(response => {
        if (response.error) {
          this.error = true;
          this.preview = false;
          if (Array.isArray(response.data)) {
            this.errorList = response.data.map(item => item.toString());
          }
        }
        this.dataSourceRecibidas = response.data as LibroFacturasRecibidas[];
        this.preview = false;

      });
      this.done = true;
    } else {
      alert('Por favor, selecciona una opción.');
    }
  }

  start() {
    this.progress = 0.5;
    this.importDone = false;
    this.loading = true;
    if (this.emitidas) {
      this.accountingService.importBookEmitidas(this.dataSourceEmitidas).then(response => {
        this.done = false;
        this.importDone = true;
        this.loading = false;
      });
    } else {
      this.accountingService.importBookRecibidas(this.dataSourceRecibidas).then(response => {
        this.done = false;
        this.importDone = true;
        this.loading = false;
      });
    }
  }

  public trackByIndex(i: number) { return i; }

}
